import { Route, Routes } from 'react-router-dom';

import RequestsPage from './requests-page';

export default function Requests() {
    return (
        <Routes>
            <Route
                path="/:id?"
                element={<RequestsPage />}
            />
        </Routes>
    );
}